module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error flexcenter"
  }, [_c('transition', [_c('div', {
    staticClass: "err flexcenter"
  }, [(_vm.buttonKind === 'login') ? _c('div', [(_vm.isEnvironmentPc()) ? _c('div', [_c('p', [_vm._v("再度サインインしてください。")]), _vm._v(" "), _c('p', [_vm._v("改善しない場合は、"), _c('a', {
    attrs: {
      "href": "https://www.sourcenext.com/support/qa/?faq=RS-09396",
      "target": "_blank"
    }
  }, [_vm._v("サポートページ")]), _vm._v("をご覧ください。")])]) : _c('div', [_vm._v("再度サインインしてください")])]) : _c('div', [_c('div', [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), (_vm.buttonKind === 'login') ? _c('div', {
    staticClass: "align-center"
  }, [_c('button', {
    staticClass: "login",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("サインインする")])]) : _vm._e(), _vm._v(" "), (_vm.buttonKind === '') ? _c('div', {
    staticClass: "align-center"
  }, [_c('button', {
    staticClass: "login",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("OK")])]) : _vm._e()])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-35df9f80", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-35df9f80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = 713
// module chunks = 1